import type { ContentTableConfig } from "@gplibraries/react/components";

export const techManualsTableConfig: ContentTableConfig = {
  columns: {
    manual_id: {
      label: 'Manual ID',
      headingStyles: {
        mobile: {
          width: '70px'
        }
      }
    },
    manual_file: {
      label: 'Manual File',
      data_type: 'link',
      headingStyles: {
        mobile: {
          width: '100px'
        }
      }
    },
    manual_description: {
      label: 'Manual Description',
      headingStyles: {
        desktop: {
          width: '50%'
        },
        mobile: {
          width: '200px'
        }
      }
    },
    machine_type: {
      label: 'Machine Type',
      headingStyles: {
        mobile: {
          width: '100px'
        }
      }
    },
    post_date: {
      label: 'Post Date',
      render: (row: any) => row.post_date ? new Date(row.post_date).toLocaleDateString() : null,
      headingStyles: {
        mobile: {
          width: '80px'
        }
      }
    }
  }
}